import { useSyncExternalStore } from 'react'

export const WIDE_WORKSPACE_QUERY = '(min-width: 64rem) and (min-height: 26.9375rem)'

const mediaQuery = (): MediaQueryList | null =>
  typeof window.matchMedia === 'function' ? window.matchMedia(WIDE_WORKSPACE_QUERY) : null

const subscribe = (onChange: () => void): (() => void) => {
  const query = mediaQuery()
  if (query === null) return () => undefined
  query.addEventListener('change', onChange)
  return () => query.removeEventListener('change', onChange)
}

const isWide = (): boolean => mediaQuery()?.matches ?? false

export const useWideWorkspace = (): boolean => useSyncExternalStore(subscribe, isWide, () => false)
